<template>
  <!-- <div class="groupDivide"> -->
	<!--
	<ul class="groupItem featureList">
		<li class="featureItem" v-for="(feature, index) in list" :feature="feature" :index="index">{{feature}}</li>
	</ul>
	-->
	<div class="groupItem featureList">
		<PreRegistration :feature="preRegistration" class="featureItem"/>
		<FeatureItem class="featureItem" v-for="(feature, index) in list" :key="index" :feature="feature" :index="index">{{feature}}</FeatureItem>
	</div>

  <!-- </div> -->
</template>


<script>
import FeatureItem from './FeatureItem.vue';
import PreRegistration from './PreRegistration.vue';
import AnimatedNumber from './AnimatedNumber.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon}  from '@fortawesome/vue-fontawesome'

library.add(faUser)

export default {
  name: 'eventPreEngagement',
    components: {
	FeatureItem,
	PreRegistration,
	AnimatedNumber,
	FontAwesomeIcon
  },
  data() { return  {
		preRegistration: 		  { 'title' : 'Pre Registration', 'img': 'Using_Computer.jpeg',
		  'blurb' : 'Create customizable registration forms to collect the attendee information you need to run your event without a hitch.'},
	  list: [
		  { 'title' : 'Event Communication', 'img': 'Using_Computer.jpeg',
		  'blurb' :  'Manage and execute effective mass-messaging for all of your attendees. Send invitations, event updates, and helpful reminders to maximize attendance and attendee engagement.' },
		  { 'title' : 'Event + Venue / Location Info', 'img': 'ConstructionManagement.jpg',
		  'blurb' : 'Find a venue that matches your meeting with hands-on assistance for even the trickiest locations.'},
		  { 'title' : 'Secure Data Capture / Login / Password', 'img': 'ITSolutions.jpg',
			'blurb' : 'Protect your event information and registration behind robust security with multi-tiered role access support that meets your strictest security requirements.'},
			{ 'title': 'Security at Rest', 'img': '2008.jpg',
			'blurb' : 'Store your data in one of multiple triple redundant data centers with SSAE16 SOC1; SOC 2; SOC 3 and ISO 27000 certification, all within the continental united states.'},
		  { 'title' : 'PHQ Travel / Hotel Management', 'img': 'DesignFabrication.jpg',
		  'blurb' : 'Keep track of your attendees in transit and on the ground with support for flight and accommodation booking and management.'},
	  ],
	  value: 10000,
      duration: 0,
	  stopAt: 0,
	  switchDuration: true,
	  updateFunc: null
    }
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.groupDivide {
	display: flex;
    flex-direction: row;
	flex-wrap: nowrap;
}
.groupItem {
	width: 100%;
	// margin: 1%;
}
.counterScreen {
	padding-top: 3%;
	border: solid 1px $darkblue;
	background-color: $blue;
}
.counterText {
	position: absolute;
  	font-size: 2rem;
  	color: black;
  	transform: translate(25px,250%);
  	-ms-transform: translate(-100%,-100%);
}
.counterUser {
	font-size: 10rem;
	color: white;
}
.featureList {
        display: flex;
        flex-direction: row;
		flex-wrap: wrap;
        justify-content: center;
}
.featureItem {
	max-width: 350px;
}
</style>